import type { ContactFormContent } from '@/components/ContactForm'
import { BAND_FIELDS_EN, BAND_FIELDS_TR, BAND_FORM_EN, BAND_FORM_TR } from './bandForm'

/**
 * The Partner Program page's own form.
 *
 * Asked for on 2026-08-30: the three partnership models described further up
 * that page should be tickable in the form under them, more than one at a time,
 * with a "tell us about yourself / your company" box that is offered rather than
 * insisted on — *"en az 1 partnership type seçebilir olsun"*.
 *
 * It is the closing band's form (`BAND_FORM_EN`) with two fields added, not a
 * second form written out: the name, email, company, country and industry
 * questions are the same questions, and a copy of them here would drift the
 * first time somebody edited the band. Only the two partner-specific fields
 * live in this file. It spreads `BAND_FIELDS_*` rather than `BAND_FORM_*.fields`
 * because the band now ends on a message box of its own, and the tier question
 * belongs above the box this page words in its own way.
 *
 * The three option labels are the card titles from the page above, verbatim and
 * in English in both locales — the Turkish page names the tiers in English too,
 * because they are the programme's names rather than descriptions.
 *
 * Because this page now carries a form of its own, it opts out of the shared
 * closing band in `app/Layout.tsx`; otherwise the page would end on the same
 * form twice, and `#contact` — which every "Become a Partner" button on it
 * points at — would be an id appearing twice in one document.
 */
const TIERS = ['Consulting Partners', 'Solution Partners', 'Platform Partners']

export const PARTNER_FORM_EN: ContactFormContent = {
  ...BAND_FORM_EN,
  fields: [
    ...BAND_FIELDS_EN,
    {
      name: 'partnership_type',
      label: 'Which partnership are you interested in? (Choose one or more)',
      type: 'checkboxes',
      required: true,
      options: TIERS,
    },
    {
      name: 'message',
      label: 'Tell us about yourself / your company',
      type: 'textarea',
    },
  ],
}

export const PARTNER_FORM_TR: ContactFormContent = {
  ...BAND_FORM_TR,
  fields: [
    ...BAND_FIELDS_TR,
    {
      name: 'partnership_type',
      label: 'Hangi iş ortaklığı modeliyle ilgileniyorsunuz? (Birden fazla seçebilirsiniz)',
      type: 'checkboxes',
      required: true,
      options: TIERS,
    },
    {
      name: 'message',
      label: 'Kendinizden ve şirketinizden biraz bahsedin',
      type: 'textarea',
    },
  ],
}
